import './style.css';

export interface ButtonProps {
    title: string;   
    disabled?: boolean;
    onClick?: () => void;
    type?: "button" | "submit" | "reset";
}

function ButtonPrimary({ title, onClick, disabled = false, type = "button" }: ButtonProps) {
    return (
        <div className="container_button">
            <button type={type} className="container_button__primary" onClick={onClick} disabled={disabled}>{title}</button>
        </div>
    )
} 

export default ButtonPrimary;
